'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Array$from = require('babel-runtime/core-js/array/from')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _PostActions = require('./PostActions');

var _PostActions2 = _interopRequireDefault(_PostActions);

var _PostRelated = require('./PostRelated');

var _PostRelated2 = _interopRequireDefault(_PostRelated);

var _components = {
  _$PostContent: {
    displayName: 'PostContent'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostContent.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostContent.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var PostContent = (function (_Component) {
  _inherits(PostContent, _Component);

  function PostContent() {
    _classCallCheck(this, _PostContent);

    _Component.apply(this, arguments);
  }

  PostContent.prototype.componentDidMount = function componentDidMount() {
    var tablesList = document.querySelectorAll('.post-content table');
    _Array$from(tablesList).forEach(function (item) {
      item.outerHTML = '<div class="scrollable">' + item.outerHTML + '</div>';
    });
  };

  PostContent.prototype.render = function render() {
    var post = this.props.post;

    return _react2['default'].createElement(
      'div',
      { className: 'container' },
      _react2['default'].createElement(
        'div',
        { className: 'row' },
        _react2['default'].createElement(
          'div',
          { className: 'col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3' },
          _react2['default'].createElement(
            'article',
            { className: 'post-content' },
            _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: post.content.rendered } })
          ),
          _react2['default'].createElement(_PostActions2['default'], null),
          _react2['default'].createElement(_PostRelated2['default'], null)
        )
      )
    );
  };

  _createClass(PostContent, null, [{
    key: 'propTypes',
    value: {
      post: _react.PropTypes.object.isRequired
    },
    enumerable: true
  }]);

  var _PostContent = PostContent;
  PostContent = _wrapComponent('_$PostContent')(PostContent) || PostContent;
  return PostContent;
})(_react.Component);

exports['default'] = PostContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PostSingle/PostContent.js
// module id = 670
// module chunks = 0